import { FC, ReactNode, useEffect, useRef, useState } from "react";
import {
  TransferAccountOption,
  TransferAccountSelector,
  TransferForm,
} from "./TransferModal";

export const ReceivingInstructions: FC<{
  source?: ReactNode;
  label: ReactNode;
  name: string;
  options: TransferAccountOption[];
  preferredAddress?: string;
  onAddressChange?: (address: string) => void;
  onConnect: () => void;
  details?: (address: string) => ReactNode;
  footer: (address: string) => ReactNode;
}> = ({
  source,
  label,
  name,
  options,
  preferredAddress,
  onAddressChange,
  onConnect,
  details,
  footer,
}) => {
  const [address, setAddress] = useState("");
  const onAddressChangeRef = useRef(onAddressChange);
  useEffect(() => {
    onAddressChangeRef.current = onAddressChange;
  }, [onAddressChange]);
  const selectedAddress = options.some((option) => option.address === address)
    ? address
    : options.find((option) => option.address === preferredAddress)?.address ||
      options[0]?.address ||
      "";

  useEffect(() => {
    if (selectedAddress !== address) setAddress(selectedAddress);
  }, [address, selectedAddress]);

  useEffect(() => {
    onAddressChangeRef.current?.(selectedAddress);
  }, [selectedAddress]);

  return (
    <TransferForm
      source={source}
      amount={null}
      destination={
        <TransferAccountSelector
          label={label}
          name={name}
          options={options}
          value={selectedAddress}
          onChange={(option) => setAddress(option.address)}
          onConnect={onConnect}
          showAddressActions
        />
      }
      details={details?.(selectedAddress)}
      footer={footer(selectedAddress)}
    />
  );
};
